import { useReactiveVar } from '@apollo/client'

import { labelCodeIdVar, spaceIdVar } from 'modulesCommon/store'
import { useGetUpcomingToursQuery } from '../graphql/queries/getUpcomingTours.types'

const useGetUpcomingTours = () => {
  const spaceId = useReactiveVar(spaceIdVar)
  const labelId = useReactiveVar(labelCodeIdVar)

  const { data }  = useGetUpcomingToursQuery({
    variables: {
      input: {
        spaceId,
        labelId
      }
    },
  })

  return {
    upcomingTours: data?.getUpcomingConcerts?.concerts || []
  }
}

export default useGetUpcomingTours
